<script setup>
import DescriptionInline from './DescriptionInline.vue'
import Header from './Header.vue'
import ButtonSubmit from './ButtonSubmit.vue'
import ButtonCancel from './ButtonCancel.vue'
import api from '../api/api'
import {flashMessage} from "../functions.js";
</script>
<template>
  <section>
    <!-- Manage Program Section -->
    <div class="programBox">
      <Header label="Manage program" />
      <div class="formBox">
        <div>
          <label for="programName"
            ><DescriptionInline label="Program name"
          /></label>
          <input
            id="programName"
            class="formControl"
            v-model="addProgramInput"
          />
        </div>

        <div class="buttonBox">
          <ButtonSubmit
            label="Add"
            :disabled="!addProgramInput"
            @click.prevent="addProgram()"
          />
          <ButtonCancel
            label="Cancel"
            :disabled="!addProgramInput"
            @click="clearAddField()"
          />
        </div>
      </div>

      <div class="formBox">
        <div>
          <label for="selectProgram"
            ><DescriptionInline label="Select program*"
          /></label>
          <select
            class="formControl"
            id="selectProgram"
            v-model="chosenProgram"
            @change="selectProgram($event)"
          >
            <option disabled selected>Select program</option>
            <option
              v-for="program in sortProgram"
              :value="program.program_name"
              :key="program.program_id"
            >
              {{ program.program_name }}
            </option>
          </select>

          <label for="newProgramName"
            ><DescriptionInline label="Program name*"
          /></label>
          <input
            id="newProgramName"
            class="formControl"
            v-model.lazy="chosenProgram"
            :disabled="!chosenProgram"
          />
        </div>

        <div class="buttonBox">
          <ButtonSubmit
            label="Update"
            :disabled="!chosenProgram"
            @click.prevent="updateProgram()"
          />
          <ButtonCancel
            label="Cancel"
            :disabled="!chosenProgram"
            @click="clearUpdatedField()"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ManageProgramBox',
  component: [DescriptionInline, ButtonSubmit, ButtonCancel, Header],
  props: ['userData','brandData','newSuborg','suborgId'],

  data: () => ({
    programList: [],
    addProgramInput: '',
    chosenProgramId: '',
    chosenProgram: '',
    addClick: null,
  }),

  watch: {
    suborgId: {
      handler: async function (newValue, oldValue) {
        if (newValue !== oldValue) {
          // Clear current selections when suborg changes
          this.chosenProgram = '';
          this.addProgramInput = '';
          this.chosenProgramId = '';
          this.programList = [];
        }
        if (newValue) {
          this.chosenSubOrgId = newValue;
          try {
            const res = await api.get(`programs/suborg/${newValue}`)
            if (res) {
              this.programList = res.data
              console.log('Loaded programs:', res.data)
            }
          } catch (error) {
            flashMessage(this.$flashMessage, this.brandData.accent_color1 ? this.brandData.accent_color1 : '#F47820', this.brandData.flash_text_color ? this.brandData.flash_text_color : '#ffffff', error.message)
          }
        }
      },
      immediate: true
    },
    programId: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          // Clear selections when program changes
          this.selectToManageProgram = "";
          this.chosenIteration = "";
          this.addIterationinput = "";
          this.iterationList = [];
          this.chosenTimezone = "";
          this.finalDeadlineDate = "";
        }
        if (newValue) {
          this.chosenProgramId = newValue;
          api.get(`iterations/programs/${newValue}`).then((res) => {
            this.iterationList = res.data;
          });
        }
      },
      immediate: true
    },
    newProgram: {
      handler: function () {
        if (this.chosenSuborgId) {
          api.get(`programs/suborg/${this.chosenSuborgId}`).then((res) => {
            this.programList = res.data;
          });
        }
      },
    },
  },
  computed: {
    sortProgram() { 
      return this.programList.sort((a, b) => (a.program_name.toUpperCase() < b.program_name.toUpperCase()) ? -1 : ((b.program_name.toUpperCase() > a.program_name.toUpperCase()) ? 1 : 0))
    },
  },
  methods: {
  computed: {
    sortProgram() { 
      return this.programList.sort((a, b) => (a.program_name.toUpperCase() < b.program_name.toUpperCase()) ? -1 : ((b.program_name.toUpperCase() > a.program_name.toUpperCase()) ? 1 : 0))
    },
  },

    async selectProgram(e) {
      let chosenProgram = e.target.value
      for (const data of this.programList) {
        if (data.program_name === chosenProgram) {
          this.chosenProgramId = data.program_id
          break
        }
      }
      
      // Emit the programId and name to parent
      this.$emit('passedProgramId', this.chosenProgramId)
      this.$emit('programSelected', chosenProgram)
    },

    async addProgram() {
      let duplication = false
      for (const data of this.programList) {
        if (
          data.program_name.toUpperCase() === this.addProgramInput.toUpperCase()
        ) {
          flashMessage(this.$flashMessage, this.brandData.accent_color1 ? this.brandData.accent_color1 : '#F47820', this.brandData.flash_text_color ? this.brandData.flash_text_color : '#ffffff', this.addProgramInput+ " already exist!")
          duplication = true
        }
      }
      if (!duplication) {
        try {
          const res = await api.post('programs', {
            program_name: this.addProgramInput.trim(),
            org_id: this.userData.org_id,
            suborg_id: this.chosenSubOrgId,
            created_by: this.userData.ind_id,
            modified_by: this.userData.ind_id,
          })
          if (res) {
            flashMessage(this.$flashMessage, this.brandData.accent_color1 ? this.brandData.accent_color1 : '#F47820', this.brandData.flash_text_color ? this.brandData.flash_text_color : '#ffffff', "Successfully added program!")
          }
        } catch (error) {
          flashMessage(this.$flashMessage, this.brandData.accent_color1 ? this.brandData.accent_color1 : '#F47820', this.brandData.flash_text_color ? this.brandData.flash_text_color : '#ffffff', error.message)
        }
      }

      try {
        const res = await api.get(`programs/suborg/${this.chosenSubOrgId}`)
        if (res) {
          this.programList = res.data
        }
      } catch (error) {
        flashMessage(this.$flashMessage, this.brandData.accent_color1 ? this.brandData.accent_color1 : '#F47820', this.brandData.flash_text_color ? this.brandData.flash_text_color : '#ffffff', error.message)
      }
      this.addClick++
      this.$emit('addProgram', this.addClick)
    },

    async updateProgram() {
      let duplication = false
      let noSpacesEnd = this.chosenProgram.endsWith(' ')
      let noSpacesStart = this.chosenProgram.startsWith(' ')
      for (const data of this.programList) {
        if (
          data.program_name.toUpperCase() === this.chosenProgram.toUpperCase()
        ) {
          flashMessage(this.$flashMessage, this.brandData.accent_color1 ? this.brandData.accent_color1 : '#F47820', this.brandData.flash_text_color ? this.brandData.flash_text_color : '#ffffff', this.chosenProgram+ " already exist!")
          duplication = true
        }
      }
      if (!duplication) {
        if(noSpacesEnd === false && noSpacesStart === false) {
          try {
            const res = await api.put(`programs/${this.chosenProgramId}`, {
              program_name: this.chosenProgram,
              modified_by: this.userData.ind_id,
            })
            if (res) {
              flashMessage(this.$flashMessage, this.brandData.accent_color1 ? this.brandData.accent_color1 : '#F47820', this.brandData.flash_text_color ? this.brandData.flash_text_color : '#ffffff', "Successfully updated program!")
            }
          } catch (error) {
            flashMessage(this.$flashMessage, this.brandData.accent_color1 ? this.brandData.accent_color1 : '#F47820', this.brandData.flash_text_color ? this.brandData.flash_text_color : '#ffffff', error.message)
          }
        } else {
          flashMessage(
            this.$flashMessage,
            this.brandData.accent_color1
              ? this.brandData.accent_color1
              : "#F47820",
            this.brandData.flash_text_color
              ? this.brandData.flash_text_color
              : "#ffffff",
            "Please remove extra spaces in the beginning or end of the program name"
          );
        }

        try {
          const res = await api.get(`programs/suborg/${this.chosenSubOrgId}`)
          if (res) {
            this.programList = res.data
          }
        } catch (error) {
          flashMessage(this.$flashMessage, this.brandData.accent_color1 ? this.brandData.accent_color1 : '#F47820', this.brandData.flash_text_color ? this.brandData.flash_text_color : '#ffffff', error.message)
        }
      }
      this.addClick++
      this.$emit('updateProgram', this.addClick)
    },

    clearAddField() {
      this.addProgramInput = ''
    },

    clearUpdatedField() {
      this.chosenProgram = ''
    },
  },
}
</script>

<style scoped>
.programBox {
  padding-bottom: 20px;
  margin-bottom: 20px;
  font-size: 14px;
}
.formControl {
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border-width: 0 0 1px;
  border-color: grey;
  padding: 2px 5px;
  margin-bottom: 1em;
  outline: 0;
  width: -webkit-fill-available;
}
input, select, option, textarea {
  border: 1px solid grey;
}
.formBox > div > label {
  display: block;
  margin-top: 1rem;
}

.formBox > div > label:first-child {
  margin-top: 0;
}

.formControl {
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border-width: 0 0 1px;
  border-color: grey;
  padding: 2px 5px;
  margin-bottom: 1em;
  outline: 0;
  width: -webkit-fill-available;
  display: block; /* Ensure form controls are block elements */
}
</style>
